import { dateString } from '../dateString.js';
import { collectPayments } from '../payments/occurrences.js';
import { projectedPayments } from './projectedPayments.js';
function dueInYear(payment, yearStart, yearEnd) {
    return collectPayments(payment, { currentDate: yearStart }, yearEnd)
        .filter(({ dueDate }) => dueDate >= yearStart && dueDate <= yearEnd)
        .sort((a, b) => a.dueDate.localeCompare(b.dueDate));
}
const monthsOf = (dates) => new Set(dates.map(({ dueDate }) => dueDate.slice(0, 7)));
export function expenseFyAmounts(rows, fiscalYear) {
    const yearStart = dateString(`${fiscalYear}-01-01`);
    const yearEnd = dateString(`${fiscalYear}-12-31`);
    const active = rows.filter((row) => row.status === 'active');
    const projected = projectedPayments(active.map((row) => ({
        ownershipDisplayId: 'page',
        estimate: row.isRunRate,
        spec: row.scheduleSpec,
    })), yearStart, yearEnd);
    const counted = new Map(active.map((row, i) => [row.displayId, projected[i]]));
    return new Map(rows.map((row) => {
        const own = dueInYear(row.scheduleSpec, yearStart, yearEnd);
        const firstAmount = own[0]?.amount ?? null;
        const payment = counted.get(row.displayId);
        if (payment === undefined) {
            return [row.displayId, { total: 0, replacedMonths: 0, firstAmount, counted: false }];
        }
        const kept = dueInYear(payment, yearStart, yearEnd);
        const keptMonths = monthsOf(kept);
        const replacedMonths = [...monthsOf(own)].filter((month) => !keptMonths.has(month)).length;
        return [
            row.displayId,
            {
                total: kept.reduce((sum, { amount }) => sum + amount, 0),
                replacedMonths,
                firstAmount,
                counted: true,
            },
        ];
    }));
}
//# sourceMappingURL=expenseRegister.js.map